import * as ActionTypes from './actions';

const lookupsInitialState = {
	titleTypes: [],
	discountTypes: [],
	referralSourceTypes: []
};

export const lookups = (state = lookupsInitialState, action) => {
	switch (action.type) {
		case ActionTypes.LOOKUPS_SUCCESS:
			return action.payload;
		default:
			return state;
	}
};

const franchisorInitialState = {
	initializing: true,
	id: '',
	systemName: '',
	subdirectory: '',
	utcOffsetHours: 0,
	phoneNumber: '',
	individualConsultationQuestionnaireUrl: '',
	countryCode: '',
	currency: '',
	trackFacebookPixel: false,
	enableCustomerChat: false,
	metaTags: {}
};

export const franchisor = (state = franchisorInitialState, action) => {
	switch (action.type) {
		case ActionTypes.FRANCHISOR_SUCCESS:
			const franchisor = action.payload;

			return { ...state, initializing: false, ...franchisor };
		case ActionTypes.FRANCHISOR_DETAILS_SUCCESS:
			return { ...state, ...action.payload };
		default:
			return state;
	}
};